import DisabledGuestForm from '../../forms/DisabledGuestForm';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Modal from 'react-modal';
import Button from '../../components/Button';
import { useContext, useEffect, useState } from 'react';
import sendEmailToGuest from '../../functions/sendEmailToGuest';
import GlobalContext from '../../contexts/GlobalContext';

const GuestConfirmationPage = () => {
    const { user, guest } = useContext(GlobalContext);
    const [showLoyaltyModal, setShowLoyaltyModal] = useState<boolean>(true);

    useEffect(() => {
        (async () => sendEmailToGuest(guest, user))();
    }, [guest, user]);

    const loyaltyNumber = (guest?.guestID || '').toUpperCase();

    return (
        <Container containerName={'landing'}>
            <Modal
                isOpen={showLoyaltyModal && !!loyaltyNumber}
                onRequestClose={() => setShowLoyaltyModal(false)}
                className="modal"
                overlayClassName="overlay"
                ariaHideApp={false}
            >
                <h1 style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
                    Loyalty #
                </h1>
                <p
                    style={{
                        textAlign: 'center',
                        color: '#aaa',
                        marginTop: 0,
                        marginBottom: '1rem',
                    }}
                >
                    Read this number to the guest. They will need it to create
                    their kupartybus account.
                </p>
                <div
                    style={{
                        fontSize: '4rem',
                        fontWeight: 700,
                        textAlign: 'center',
                        letterSpacing: '0.25rem',
                        padding: '1.5rem',
                        border: '3px solid #22c55e',
                        borderRadius: '0.75rem',
                        marginBottom: '1.5rem',
                        color: '#22c55e',
                        background: 'rgba(34,197,94,0.08)',
                    }}
                >
                    {loyaltyNumber}
                </div>
                <Button
                    color={'green'}
                    margin={true}
                    onClick={() => setShowLoyaltyModal(false)}
                >
                    Got it
                </Button>
            </Modal>
            <Header
                title={'Confirmation Page'}
                subtitle={''}
                bottomBorder={true}
            />
            {loyaltyNumber && (
                <div
                    style={{
                        textAlign: 'center',
                        margin: '0 auto 1rem',
                        padding: '0.75rem 1rem',
                        border: '2px solid #22c55e',
                        borderRadius: '0.5rem',
                        maxWidth: '32rem',
                        background: 'rgba(34,197,94,0.08)',
                    }}
                >
                    <div style={{ color: '#aaa', fontSize: '0.9rem' }}>
                        Loyalty # (give to guest)
                    </div>
                    <div
                        style={{
                            fontSize: '2rem',
                            fontWeight: 700,
                            letterSpacing: '0.2rem',
                            color: '#22c55e',
                        }}
                    >
                        {loyaltyNumber}
                    </div>
                </div>
            )}
            <DisabledGuestForm />
        </Container>
    );
};

export default GuestConfirmationPage;
